import { Path, Svg } from '../../svg';

/**
 * Flashka flashcard glyph — the horizontally-split card mark used for
 * flashcard counts (DS card activity chips). Bespoke (not in lucide), drawn
 * once with the shared SVG primitives so it renders identically on web +
 * native. Path lifted from flashka-web's `src/components/icons/flashcard.tsx`
 * (16×16 viewBox).
 *
 * Matches the `IconComponent` contract ({ color, size }) so shared components
 * (Badge chips, Button icons) can inject colour and size.
 */
export function FlashcardIcon({
  color = '#525252',
  size = 16,
  className,
}: {
  color?: string;
  size?: number;
  /** Forwarded to the svg — e.g. Badge/Button pass `shrink-0`. */
  className?: string;
}) {
  return (
    // viewBox padded 1.6 per side: the glyph spans its full 16 box, while
    // lucide art occupies ~20 of its 24 box — rendered at the same px, the
    // edge-to-edge glyph read ~20% bigger than the sibling chip icons.
    // 16/19.2 = lucide's 20/24, so the chips now match optically.
    <Svg
      width={size}
      height={size}
      viewBox="-1.6 -1.6 19.2 19.2"
      fill="none"
      className={className}>
      <Path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.33 8.835H1.67V12C1.67 13.2868 2.71318 14.33 4 14.33H12C13.2868 14.33 14.33 13.2868 14.33 12V8.835ZM14.33 7.165H1.67V4C1.67 2.71318 2.71318 1.67 4 1.67H12C13.2868 1.67 14.33 2.71318 14.33 4V7.165ZM16 4C16 1.79086 14.2091 0 12 0H4C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4Z"
      />
    </Svg>
  );
}
